module.exports = __webpack_public_path__ + "img/wild3.2456e966.png";